// extracted by mini-css-extract-plugin
module.exports = {"container":"card_container__IvTAx"};